<template >
    <div class="page">
        <div class="form">
            <div class="item">
                <label>原密码</label>
                <div class="input">
                    <input type="password" v-model="form.old_password" placeholder="请输入">
                </div>
            </div>
            <div class="item">
                <label>新密码</label>
                <div class="input">
                    <input type="password" v-model="form.password" placeholder="请输入">
                </div>
            </div>
            <div class="item">
                <label>确认密码</label>
                <div class="input">
                    <input type="password" v-model="form.confirm_password" placeholder="请输入">
                </div>
            </div>
            <div class="item-tips">
                <div class="td-fcc">
                    <img :src="Images.icon_stress" />
                    <span>新密码长度要大于6位</span>
                </div>
                <div class="td-fcc">
                    <span>建议您定期更换密码，确保账号安全</span>
                </div>
            </div>
            <div class="btn-box td-f">
                <Btn class="btn td-f1 td-fcc" loading @confirmEvent="submitForm">确定</Btn>
            </div>
        </div>
    </div>
</template>

<script>
import Lockr from 'lockr'

export default {
    /** 数据区 */
    data() {
        return {
            countDown: 60,
            is_wait: false,
            code_btn_text: "获取验证码",
            form: {
                old_password: "",
                password: "",
                confirm_password: ""
            }
        };
    },
    /** 方法 */
    methods: {
        // 提交表单
        async submitForm (done) {
            let {old_password, password, confirm_password} = this.form
            if (!old_password) {
                this.Message({
                    title: '请输入原密码'
                })
                done&&done()
                return
            }
            if (!password) {
                this.Message({
                    title: '请输入新密码'
                })
                done&&done()
                return
            }
            if (password.length < 6) {
                this.Message({
                    title: '请输入至少6位由数字或字母组成的密码'
                })
                done&&done()
                return
            }
            if (password !== confirm_password) {
                this.Message({
                    title: '两次密码输入不一致，请重新输入'
                })
                done&&done()
                return
            }
            let url = this.API.reset_password;
            let params = {
                old_password: old_password,
                new_password: password,
                confirm_password: confirm_password,
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            done();
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.$store.dispatch("UserInfo", true);
                this.Message({
                    title: '登录密码修改成功，请使用新密码登录',
                    time: 2000,
                    onClose: ()=>{
                        this.$router.go(-1);
                    }
                })
            } else {
                this.Message({
                    title: result.msg,
                });
            }
            
        }
    },
};
</script>

<style lang="less" scoped>
.form{
    padding: 10px 15px;
    .item {
        padding: 0 10px;
        height: 50px;
        border-radius: 5px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;

        label {
            margin-right: 10px;
            font-size: 15px;
            color: #333;
            flex-shrink: 0;
        }
        .input{
            flex: 1;
            height: 50px;
        }
        input {
            width: 100%;
            line-height: 50px;
            font-size: 14px;
            color: #333;
            text-align: right;
        }
        .code{
            min-width: 80px;
            text-align: center;
            font-size: 14px;
            color: #7181eb;
            flex-shrink: 0;
            line-height: 14px;
            padding-left: 10px;
            margin-left: 10px;
            border-left: solid #7181eb 1px;
        }
    }
    .item-tips{
        display: flex;
        flex-direction: column;
        padding-top: 15px;
        img{
            width: 14px;
            height: 14px;
            display: block;
            margin-right: 5px;
        }
        span{
            font-size: 12px;
            color: #999;
            line-height: 2;
        }
    }
    .btn {
        height: 40px;
        background: linear-gradient(225deg,#9cb2f4, #6472e8);
        border-radius: 3px;
        font-size: 15px;
        color: #fff;
        text-align: center;
        margin-top: 40px;
    }
}
</style>